<template>
    <ModalContainer id="registerModal">
        <div class="modal-dialog modal-lg" role="document">
            <section class="modal__content">
                <header class="modal__header">
                    <div class="program-upload--input-title-wrapper">
                        <ProgramLiveStatus
                            v-if="program.id > 0 && !program.live_media_channel_hidden_at"
                            :live-status="programLiveStatus"
                        />
                        <input ref="program_title" v-model="programTitle"
                               :class="{
                                    'form-control--underline':true,
                                     'error':!isEmptyCheck(program.meta.errors.title),
                                     'include-label': isIncludeLabel
                                }"
                               :disabled="!editable"
                               :placeholder="$t('paragraphs.program_register_modal_title_placeholder')"
                               autocomplete="off"
                               name="program_title"
                               type="text"/>
                        <button
                            v-if="program.id > 0"
                            class="btn--icon btn__schedule-header"
                            @click="handleScheduleCopy"
                        >
                            <ClipBoardSvg/>
                        </button>
                        <button class="btn--icon btn__schedule-header"
                                type="button"
                                @click="handleClose"
                        >
                            <i class="icon icon-close"></i>
                        </button>

                    </div>
                    <div v-if="isEmptyCheck(program.meta.errors.title) && program.live_media_channel_hidden_at"
                         class="form-control--comment">
                        {{ $t('paragraphs.program_hide_channel_notification') }}
                    </div>
                    <FormErrorMessage :form-target="program.meta.errors.title"/>
                </header>

                <section class="modal__body">
                    <!-- row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                            {{ $t('words.channel') }}
                        </label>
                        <div class="col-md-9">
                            <SelectizeSelect
                                id="channel_select"
                                ref="channel_select"
                                v-model="selectedChannel"
                                :data="recordingChannels"
                                :disabled="!editable || program.id > 0"
                                :error="!isEmptyCheck(program.meta.errors.channel)"
                                :initValue="String(program.live_media_channel_id)"
                                :placeholder="$t('paragraphs.program_select_channel_placeholder')"
                                labelField="title"
                                searchField="title"
                                valueField="id"
                            />
                            <FormErrorMessage :form-target="program.meta.errors.channel"/>
                        </div>
                    </div>

                    <!--row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">{{ $t('words.wait_media_content') }}</label>
                        <div class="col-md-9">
                            <SelectizeSelect
                                id="select_wait_file"
                                v-model="selectedWaitMediaContents"
                                :data="waitMediaContents"
                                :disabled="!editable"
                                :placeholder="$t('paragraphs.program_wait_file_search')"
                                :search-onload="loadWaitMediaContents"
                                :set-keyword="setSearchWaitMediaKeyword"
                                labelField="title"
                                onChangeValueInit
                                searchField="title"
                                valueField="id"
                            />
                            <div
                                v-if="program.wait_file && 'id' in program.wait_file && parseInt(program.wait_file.id, 10) > 0"
                                :class="{
                                    'content-register--list-container': true,
                                     'error' :!isEmptyCheck(program.meta.errors.wait_file)
                                }"
                            >
                                <ContentRegisterListItem
                                    :disabled="!editable"
                                    :mediaContent="program.wait_file"
                                    waitMediaContent
                                    @doRemoveFile="doRemoveWaitFile"
                                />
                            </div>

                            <FormErrorMessage :form-target="program.meta.errors.wait_file"/>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">
                            {{ $t('words.wait_media_content_duration_m') }}
                        </label>
                        <div class="col-md-9">
                            <div class="input-group" style="width: 148px">
                                <input
                                    id="wait_file_duration"
                                    v-model="programWaitFileDuration"
                                    :class="{'form-control':true, 'error':!isEmptyCheck(program.meta.errors.wait_file_duration)}"
                                    :disabled="isEmptyCheck(program.wait_file) || !editable"
                                    autocomplete="off"
                                    max="360"
                                    min="0"
                                    name="wait_file_duration"
                                    type="number"
                                />
                                <div class="input-group__prepend-label" style="border: 0;">
                                    {{ $t('words.unit_minute') }}
                                </div>
                            </div>
                            <FormErrorMessage :form-target="program.meta.errors.wait_file_duration"/>
                            <div v-if="isEmptyCheck(program.meta.errors.wait_file_duration)"
                                 class="form-control--comment">
                                {{ $t('paragraphs.program_wait_file_duration_min_max') }}
                            </div>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">{{ $t('words.contents') }}</label>
                        <div class="col-md-9">
                            <SelectizeSelect
                                id="select_file"
                                v-model="selectedMediaContents"
                                :data="mediaContents"
                                :disabled="!editable"
                                :placeholder="$t('paragraphs.program_contents_search')"
                                :search-onload="loadMediaContents"
                                :set-keyword="setSearchMediaKeyword"
                                labelField="title"
                                onChangeValueInit
                                searchField="title"
                                valueField="id"
                            />
                            <div
                                v-if="program.files && program.files.length > 0 "
                                :class="{
                                    'content-register--list-container': true,
                                    'scroll': program.files.length > 2,
                                     'error' :!isEmptyCheck(program.meta.errors.files)
                                }"
                                @dragend="handleDragEnd"
                                @dragstart="handleDragStart"
                                @drop.prevent="changeFileItem"
                                @dragenter.prevent="handleDragEnter"
                                @dragover.prevent="handleDragOver"
                            >
                                <ContentRegisterListItem
                                    v-for="(file, index) in program.files"
                                    v-if="parseInt(file.id, 10) > 0"
                                    :key="index"
                                    :disabled="!editable"
                                    :dragItemIndex="dragItemIndex"
                                    :hoverItemIndex="hoverItemIndex"
                                    :index="index"
                                    :isDragging="isDragging"
                                    :mediaContent="file"
                                    use-drag
                                    @doRemoveFile="doRemoveFile(file, index)"
                                />
                            </div>

                            <div v-if="isEmptyCheck(program.meta.errors.files)" class="form-control--comment">
                                {{ $t('paragraphs.program_register_modal_contents_info') }}
                            </div>
                            <FormErrorMessage :form-target="program.meta.errors.files"/>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">{{ $t('words.total_broadcast_time') }}</label>
                        <div class="col-md-9">
                            <p class="form-control--static"> {{ fileDurationToHuman }}</p>
                        </div>
                    </div>

                    <!-- row -->
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label">{{ $t('words.broadcast_start_date') }}</label>
                        <div class="col-md-9">
                            <div id="date-picker" class="input-group">
                                <vue-date-picker
                                    v-model="broadcastStartDate"
                                    :class="{'form-control--datepicker': true, 'error': !isEmptyCheck(program.meta.errors.pickDateTime) }"
                                    :default-value="defaultDateTime"
                                    :disabled="!editable"
                                    :disabled-date="notBeforeDate"
                                    :editable="false"
                                    :minute-step="5"
                                    :showSecond="false"
                                    type="datetime"
                                />
                                <span> ~ </span>
                                <div class="form-control--datepicker mx-datepicker">
                                    <div class="mx-input-wrapper">
                                        <input v-model="calculateEndTime"
                                               class="mx-input"
                                               disabled
                                               type="text"
                                        />
                                    </div>
                                </div>

                            </div>
                            <FormErrorMessage :form-target="program.meta.errors.start_date"/>
                            <FormErrorMessage :form-target="program.meta.errors.pickDateTime"/>
                        </div>
                    </div>
                </section>

                <div v-if="haveSubmitRight && editable" class="modal__footer">
                    <button v-if="haveSubmitRight && editable && (program.id > 0)" class="btn btn-danger"
                            type="submit"
                            @click.prevent="doRemoveProgram">
                        {{ $t('words.remove') }}
                    </button>
                    <button v-if="haveSubmitRight && editable" class="btn btn-primary" type="submit"
                            @click.prevent="doSubmitProgram">
                        {{ $t('words.save') }}
                    </button>
                </div>
            </section>
        </div>
    </ModalContainer>
</template>

<script>
import _ from 'lodash';
import VueDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ModalContainer from '@/components/cms/common/Modal/ModalContainer';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import SelectizeSelect from '@/components/cms/common/UI/SelectizeSelect';
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';
import TimeIntervalMixin from '@/components/mixin/TimeIntervalMixin';
import SortableDragMixin from '@/components/mixin/SortableDragMixin';
import ContentsFinderListItem from '@/components/cms/common/Schedule/SideBar/ContentsFinderListItem';
import ContentRegisterListItem from '@/components/cms/common/Schedule/ContentRegisterListItem';
import FormErrorMessage from '@/components/cms/common/Schedule/FormErrorMessage';
import ProgramLiveStatus from '@/components/cms/common/Schedule/ProgramRegisterModal/ProgramLiveStatus';
import ClipBoardSvg from '@/components/svg/ClipBoardSvg';

export default {
    name: 'ScheduleRegisterModal',
    mixins: [
        GlobalConfigMixin,
        TimeIntervalMixin,
        SortableDragMixin,
    ],
    components: {
        ClipBoardSvg,
        FormErrorMessage,
        ContentRegisterListItem,
        ContentsFinderListItem,
        ModalContainer,
        VueDatePicker,
        SelectizeSelect,
        ProgramLiveStatus,
    },
    computed: {
        ...mapGetters({
            program: 'schedule_register_modal/program',
            editable: 'schedule_register_modal/editable',
            beforeEditData: 'schedule_register_modal/editBeforeData',
            pickDateTime: 'schedule_register_modal/pickDateTime',
            registerModalShow: 'schedule_register_modal/registerModalShow',
            recordingChannels: 'schedule/recordingChannels',
            mediaContents: 'schedule_register_modal_contents/mediaContents',
            waitMediaContents: 'schedule_register_modal_contents/waitMediaContents',
            submitProcess: 'schedule_register_modal/submitProcess',
            refetchEvents: 'calendar/refetchEvents',
        }),
        programTitle: {
            get() {
                return this.program.title;
            },
            set(val) {
                this.setProgramTitle(val);
            },
        },
        programWaitFileDuration: {
            get() {
                return this.program.wait_file_duration;
            },
            set(val) {
                this.setWaitFileDuration(val);
            },
        },
        broadcastStartDate: {
            get() {
                return this.pickDateTime;
            },
            set(val) {
                this.setPickDateTime(val);
            },
        },
        registerModalOpen: {
            get() {
                return this.registerModalShow;
            },
            set(val) {
                this.setRegisterModalShow(val);
            },
        },
        formSubmitProcess: {
            get() {
                return this.submitProcess;
            },
            set(val) {
                this.setSubmitProcess(val);
            },
        },
        defaultDateTime() {
            const nowDate = this.$moment();
            const assumeMinutes = _.ceil((nowDate.minute() + 5) / 10) * 10;
            if (assumeMinutes === 60) {
                return (new Date()).setHours(nowDate.hour() + 1, 0, 0, 0);
            }
            return (new Date()).setHours(nowDate.hour(), assumeMinutes, 0, 0);
        },
        transDateTime() {
            if (this.$moment(this.pickDateTime).isValid()) {
                const mm = this.pickDateTime.getMonth() + 1;
                const dd = this.pickDateTime.getDate();
                return `${this.pickDateTime.getFullYear()}-${(mm > 9 ? mm : `0${mm}`)}-${(dd > 9 ? dd : `0${dd}`)} ${this.pickDateTime.toTimeString().split(' ')[0]}`;
            }
            return '';
        },
        calculateEndTime() {
            if (this.transDateTime === '') {
                return '';
            }
            return this.$moment.tz(this.transDateTime, this.getLoginAccount.timezone).add(this.program.file_duration, 'milliseconds').format('YYYY-MM-DD HH:mm:ss');
        },
        fileDurationToHuman() {
            if (this.program.file_duration === 0) {
                return 0;
            }
            return this.$moment.duration(this.program.file_duration, 'milliseconds').format('HH:mm:ss', { trim: false });
        },
        programLiveStatus() {
            let status = '';
            const startUnixTime = this.$moment(this.program.start).unix();
            const endUnixTime = this.$moment(this.program.end).unix();

            if (this.current < startUnixTime) {
                status = 'before';
            } else if (this.current >= startUnixTime && this.current <= endUnixTime) {
                status = 'live';
            } else if (this.current > endUnixTime) {
                status = 'end';
            } else {
                status = 'none';
            }

            return status;
        },

        isIncludeLabel() {
            const isIncludeLabelStatus = this.programLiveStatus === 'live' || this.programLiveStatus === 'end';
            return this.program.id > 0 && isIncludeLabelStatus && !this.program.live_media_channel_hidden_at;
        },
    },
    data() {
        return {
            selectedChannel: '',
            selectedWaitMediaContents: '',
            selectedMediaContents: '',
        };
    },
    watch: {
        selectedChannel(val) {
            if (val) {
                this.selectedChannel = '';
                this.setProgramChannel(val);
            }
        },
        selectedWaitMediaContents(val) {
            if (val) {
                this.selectedWaitMediaContents = '';
                this.setWaitFile(val);
            }
        },
        selectedMediaContents: _.debounce(function (val) {
            if (val) {
                this.selectedMediaContents = '';
                this.addProgramFile(val);
            }
        }, 150),
        programLiveStatus(val) {
            if (val === 'live') {
                this.setEditable(false);
            }
        },
        registerModalShow(val) {
            if (val) {
                this.loadMediaContents();
                this.loadWaitMediaContents();
            }
        },
    },
    mounted() {
        $('#registerModal').on('hidden.bs.modal', () => {
            this.registerModalOpen = false;
            this.clearProgram();
        });

        this.loadMediaContents();
        this.loadWaitMediaContents();
    },
    methods: {
        ...mapMutations({
            setProgramTitle: 'schedule_register_modal/setProgramTitle',
            setPickDateTime: 'schedule_register_modal/setPickDateTime',
            setRegisterModalShow: 'schedule_register_modal/setRegisterModalShow',
            setProgramChannel: 'schedule_register_modal/setProgramChannel',
            addProgramFile: 'schedule_register_modal/addProgramFile',
            setProgramFile: 'schedule_register_modal/setProgramFile',
            setWaitFile: 'schedule_register_modal/setWaitFile',
            setWaitFileDuration: 'schedule_register_modal/setWaitFileDuration',
            clearProgram: 'schedule_register_modal/clearProgram',
            setSubmitProcess: 'schedule_register_modal/setSubmitProcess',
            setProgramMetaErrors: 'schedule_register_modal/setProgramMetaErrors',
            setRefetchEvents: 'calendar/setRefetchEvents',
            setEditable: 'schedule_register_modal/setEditable',
            setMetaErrors: 'schedule_register_modal/setMetaErrors',
            setCopySchedule: 'schedule_register_modal/setCopySchedule',
            setMoveFilesItem: 'schedule_register_modal/setMoveFilesItem',
            setSearchMediaKeyword: 'schedule_register_modal_contents/setSearchMediaKeyword',
            setSearchWaitMediaKeyword: 'schedule_register_modal_contents/setSearchWaitMediaKeyword',
        }),
        ...mapActions({
            loadMediaContents: 'schedule_register_modal_contents/fetchMediaContents',
            loadWaitMediaContents: 'schedule_register_modal_contents/fetchWaitMediaContents',
            createSchedule: 'schedule_register_modal/createSchedule',
            updateSchedule: 'schedule_register_modal/updateSchedule',
            removeSchedule: 'schedule_register_modal/removeSchedule',
            fetchSchedules: 'schedule/fetchSchedules',
        }),

        haveSubmitRight() {
            return this.haveOwnerRight;
        },

        notBeforeDate(date) {
            return date < (new Date()).setHours(0, 0, 0, 0);
        },

        doRemoveWaitFile() {
            this.setWaitFile(null);
        },

        doRemoveFile(file, fileIndex) {
            const programFiles = this.program.files.filter((o, index) => index !== fileIndex);
            this.setProgramFile(programFiles);
        },

        async doRemoveProgram() {
            if (!this.haveSubmitRight) {
                return;
            }
            if (!this.editable) {
                this.$toasted.error(this.$t('paragraphs.message.error.remove_program_done_schedule'));
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_program', { title: this.program.title }))) {
                try {
                    await this.removeSchedule();
                    await this.fetchSchedules();
                    await this.setRefetchEvents(true);
                    this.setRegisterModalShow(false);
                    this.$toasted.success(this.$t('paragraphs.message.success.remove_program'));
                } catch (error) {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_program'));
                    logger.error(error.response.data.errors);
                }
            }
        },

        async doSubmitProgram() {
            const submitSuccess = await this.programSubmit();

            if (submitSuccess) {
                await this.fetchSchedules();
                await this.setRefetchEvents(true);
                this.setRegisterModalShow(false);
            }
        },

        async programSubmit() {
            if (!this.haveSubmitRight) {
                this.$toasted.success(this.$t('paragraphs.message.error.check_login_right'));
                return false;
            }

            if (!this.formSubmitProcess && this.formValidation()) {
                this.formSubmitProcess = true;
                try {
                    if (this.program.id > 0) {
                        await this.updateSchedule();
                        this.$toasted.success(this.$t('paragraphs.message.success.update'));
                    } else {
                        await this.createSchedule();
                        this.$toasted.success(this.$t('paragraphs.message.success.create'));
                    }

                    return true;
                } catch (error) {
                    if (typeof error.response.data.errors === 'undefined' &&
                        typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                        this.$toasted.error(error.response.data.message, { position: 'top-center', duration: 3000 });
                    } else {
                        if (error.response.data.errors) {
                            this.setMetaErrors(error.response.data.errors);
                        }


                        if (this.program.id > 0) {
                            this.$toasted.error(this.$t('paragraphs.message.error.update'));
                        } else {
                            this.$toasted.error(this.$t('paragraphs.message.error.create'));
                        }
                    }

                    return false;
                } finally {
                    this.formSubmitProcess = false;
                }
            }

            return false;
        },

        formValidation() {
            let errors = {
                title: [],
                pickDateTime: [],
                files: [],
                channel: [],
                wait_file_duration: [],
                wait_file: [],
            };

            const checkAudioFormat = this.checkAudioFormat();
            const checkVideoFormat = this.checkVideoFormat();

            if (!this.program.title) {
                errors.title = [this.$t('paragraphs.program_title_required')];
            }

            if (this.program.wait_file && (this.program.wait_file_duration <= 0 || this.program.wait_file_duration > 360)) {
                errors.wait_file_duration = [this.$t('paragraphs.program_wait_content_duration_over_zero')];
            }

            if (!this.program.live_media_channel_id) {
                errors.channel = [this.$t('paragraphs.program_select_channel')];
            }

            if (!this.$moment(this.pickDateTime).isValid()) {
                errors.pickDateTime = [this.$t('paragraphs.program_select_start_date')];
            }

            if (this.program.files.length === 0) {
                errors.files = [...errors.files, this.$t('paragraphs.program_content_file_required')];
            }

            if (this.program.files.length > 0 && !checkAudioFormat.check) {
                errors.files = [...errors.files, checkAudioFormat.message];
                if (checkAudioFormat.waitMediaContents) {
                    errors.wait_file = [...errors.wait_file, checkAudioFormat.message];
                }
            }

            if (this.program.files.length > 0 && !checkVideoFormat.check && !(Object.entries(errors).find(el => el[1].length > 0))) {
                if (!confirm(this.$t('paragraphs.program_check_video_format_confirm', { fail_format: checkVideoFormat.failFormat }))) {
                    return false;
                }
            }

            this.setProgramMetaErrors(errors);

            return !(Object.entries(errors).find(el => el[1].length > 0));
        },
        checkAudioFormat() {
            const key = 'transcoding_file.media_information.audio';
            const formats = [
                {
                    format: 'audio_codec',
                    name: this.$t('words.audio_codec'),
                },
                {
                    format: 'audio_samplerate',
                    name: this.$t('words.sample_rate'),
                },
            ];

            return this.checkFormat(key, formats, 'audio');
        },
        checkVideoFormat() {
            const key = 'transcoding_file.media_information.video';
            const formats = [
                {
                    format: 'video_screen_size',
                    name: this.$t('words.resolution'),
                },
                {
                    format: 'video_framerate',
                    name: this.$t('words.frame_rate'),
                },
            ];

            return this.checkFormat(key, formats, 'video');
        },
        checkFormat(key, formats, type) {
            if (this.program.files.length === 0) {
                return false;
            }

            const result = {
                check: true,
                message: '',
                waitMediaContents: false,
                failFormat: '',
            };
            const measure = {};
            const measureFail = [];


            formats.forEach((item) => {
                measure[item.format] = '';
            });

            // file 마다 같은지 체크
            this.program.files.forEach((file, index) => {
                const measureFileTarget = _.get(file, key);
                formats.forEach((item) => {
                    if (index === 0) {
                        measure[item.format] = measureFileTarget[item.format];
                    } else if (index > 0 && measure[item.format] !== measureFileTarget[item.format]) {
                        result.check = false;
                        const checkDuplicateFail = measureFail.find(el => el === item.name);
                        if (!checkDuplicateFail) {
                            measureFail.push(item.name);
                        }
                    }
                    // console.log(`[${key}.${format}]-File:${check}`);
                });
            });

            if (type === 'video') {
                result.message = this.$t('paragraphs.program_check_video_format_each_contents', { fail_format: measureFail.join(', ') });
            } else if (type === 'audio') {
                result.message = this.$t('paragraphs.program_check_audio_format_each_contents', { fail_format: measureFail.join(', ') });
            }

            // 대기화면이랑 같은지 체크
            if (this.program.wait_file && result.check) {
                const measureWaitFileTarget = _.get(this.program.wait_file, key);
                formats.forEach((item) => {
                    if (measure[item.format] !== measureWaitFileTarget[item.format]) {
                        result.check = false;
                        const checkDuplicateFail = measureFail.find(el => el === item.name);
                        if (!checkDuplicateFail) {
                            measureFail.push(item.name);
                        }
                        result.waitMediaContents = true;
                    }
                    // console.log(`[${key}.${format}]-WaitFile:${check}`);
                });
                if (type === 'video') {
                    result.message = this.$t('paragraphs.program_check_video_format_between_contents_and_wait', { fail_format: measureFail.join(', ') });
                } else if (type === 'audio') {
                    result.message = this.$t('paragraphs.program_check_audio_format_between_contents_and_wait', { fail_format: measureFail.join(', ') });
                }
            }

            result.failFormat = measureFail;

            return result;
        },

        checkModified() {
            if (this.editable && this.program.id === 0) {
                return this.checkNewScheduleModified();
            } else if (this.editable && this.program.id > 0) {
                return this.checkEditScheduleModified();
            }

            return false;
        },

        checkNewScheduleModified() {
            let check = false;
            const compareObject = {
                id: 0,
                live_media_channel_id: '',
                live_media_channel_hidden_at: null,
                live_media_channel_title: '',
                title: '',
                wait_file: null,
                wait_file_duration: 0,
                files: [],
                start: null,
                end: null,
                file_duration: 0,
                meta: {
                    errors: {},
                },
            };

            if (!_.isEqual(this.program, compareObject)) {
                check = true;
            }

            if (this.pickDateTime) {
                check = true;
            }

            return check;
        },

        checkEditScheduleModified() {
            let check = false;

            if (!_.isEqual(this.program, this.beforeEditData.program)) {
                check = true;
            }

            if (this.pickDateTime !== this.beforeEditData.pickDateTime) {
                check = true;
            }

            return check;
        },

        isEmptyCheck(val) {
            return _.isEmpty(val);
        },

        handleScheduleCopy() {
            let copyProgram = this.program;
            const isModified = this.checkModified();

            if (isModified) {
                if (confirm(this.$t('paragraphs.schedule_copy_warning'))) {
                    if (this.programSubmit()) {
                        copyProgram = this.program;
                    } else {
                        return;
                    }
                } else {
                    copyProgram = this.beforeEditData.program;
                }
            }

            const {
                title,
                live_media_channel_id,
                live_media_channel_title,
                live_media_channel_hidden_at,
                wait_file,
                wait_file_duration,
                files,
                file_duration,
            } = copyProgram;

            const copyParams = {
                title,
                live_media_channel_id,
                live_media_channel_title,
                live_media_channel_hidden_at,
                wait_file,
                wait_file_duration,
                files,
                file_duration,
            };

            this.setRegisterModalShow(false);
            this.clearProgram();

            setTimeout(() => {
                this.setCopySchedule(copyParams);
                this.setRegisterModalShow(true);
            }, 500);
        },

        async handleClose() {
            // 저장되지 않은 변경사항을 삭제하시겠습니까?
            if (this.checkModified() && this.editable && this.program.id === 0 && !confirm(this.$t('paragraphs.schedule_modal_close_warning'))) {
                return;
            }

            if (this.checkModified() && this.editable && this.program.id > 0 && confirm(this.$t('paragraphs.schedule_modal_close_modified_save'))) {
                const submitSuccess = await this.programSubmit();

                if (submitSuccess) {
                    await this.fetchSchedules();
                    await this.setRefetchEvents(true);
                    this.setRegisterModalShow(false);
                } else {
                    return;
                }
            }

            this.setRegisterModalShow(false);
            this.clearProgram();
        },

        changeFileItem(e) {
            this.handleDragDrop(e, (beforeIndex) => {
                const payload = {
                    beforeIndex,
                    afterIndex: e.target.dataset.index,
                };
                this.setMoveFilesItem(payload);
            });
        },
    },
};
</script>
